import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PledgePerWinService } from '../../../_services/fundraising/pledgePerWin.service';
import { Subscriber } from '../../../_models/fundraising/ppw/Subscriber';
import { PledgePerWin } from '../../../_models/fundraising/ppw/PledgePerWin';
import { forkJoin } from 'rxjs';
import { PledgePerWinSubscriberDetailsModalComponent } from './ppw-subscribers-details-modal.component';
import { PledgePerWinCancelModalComponent } from './ppw-cancel-reverse-modal.component';
import {PledgePerWinSubscriber} from "../../../_models/fundraising/ppw/PledgePerWinSubscriber";

@Component({
  selector: 'app-ppw-subscribers-management',
  templateUrl: './ppw-subscribers-management.component.html',
  styleUrls: ['../../../_shared/base.management.component.css']
})

export class PledgePerWinSubscribersManagementComponent implements OnInit {
  public loading = true;

  public ppws: PledgePerWin[];
  public display: Subscriber[];
  public items: Subscriber[];

  public selectedCampaign: number;

  public searchText: string;

  private bsModalRef: BsModalRef;

  constructor(
    private router: Router,
    private ppwSerivce: PledgePerWinService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService) {

  }

  ngOnInit() {

    this.load();
  }

  public isActive(subscriptions: PledgePerWinSubscriber[]) {
    return subscriptions.some(subscription => !subscription.cancelled)
  }

  public search(filtered: boolean = false) {

    if (!filtered) {

      this.display = Array.from(this.items);
    }

    if (!this.searchText) {

      return;
    }

    let quoteRegex = /[^\s"]+|"([^"]*)"/gi;
    let searchTerms = [];
    let match;

    do {

      match = quoteRegex.exec(this.searchText.toLowerCase());

      if (match != null) {

        searchTerms.push(match[1] ? match[1] : match[0]);
      }

    } while (match != null);


    let searched = [];

    searchTerms.forEach(
        s => {
            const f = this.display.filter(d =>
                (d.firstName ? d.firstName.toLowerCase().indexOf(s) !== -1 : false) ||
                (d.lastName ? d.lastName.toLowerCase().indexOf(s) !== -1 : false) ||
                (d.phone ? d.phone.indexOf(s) !== -1 : false) ||
                (d.email ? d.email.indexOf(s) !== -1 : false) ||
                !s);

            f.forEach(
                y => {
                    searched.push(y);
                    this.display.splice(this.display.indexOf(y), 1);
                }
            )
        }
    );

    this.display = searched;
  }

  filterByCampaign () {

    if (this.selectedCampaign === -1) {

      this.display = this.items.filter(s => s.subscriptions.every(sub => sub.cancelled))
        .concat(this.items.filter(s => s.subscriptions.length < 1));

    } else if (this.selectedCampaign === 0) {

      this.display = [...this.items];

    } else if (this.selectedCampaign) {

      this.display = this.items.filter(s => s.subscriptions.some(sub => sub.pledgePerWinId === this.selectedCampaign))
    }

    this.search(true);
  }

  private load() {

    this.spinner.show();

    const ppwObs = this.ppwSerivce.getAll();
    const subscriberObs = this.ppwSerivce.getAllSubscribers();

    forkJoin([ppwObs, subscriberObs])
        .subscribe(
            data => {

                this.spinner.hide();

                this.ppws = data[0].pledgePerWins;
                this.items = data[1];
                this.display = [...this.items];
            },
            error => {

                this.spinner.hide();
                this.dialogService.alert("Oops something went wrong...",
                    "We were unable to process your request at this time, please try again in a few moments. Please contact CUE support at support@connectwithcue.com if you continue to experience issues",
                    this.viewRef);
            }
        );
  }

  openDetailsModal(subscriberId: number) {

    const modalConfig = {
        backdrop: true,
        ignoreBackdropClick: true
      };

      const initialState = {
        subscriber: this.items.find(s => s.pledgePerWinSubscriberId == subscriberId),
        viewRef: this.viewRef
      };

      this.bsModalRef = this.modalService
        .show(
          PledgePerWinSubscriberDetailsModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-lg', initialState }));
  }

  cancelOrReverse(subscriberId: number) {

    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      subscriber: this.items.find(s => s.pledgePerWinSubscriberId == subscriberId),
      viewRef: this.viewRef
    };

    this.bsModalRef = this.modalService
      .show(
        PledgePerWinCancelModalComponent,
        Object.assign({}, modalConfig, { class: 'modal-md', initialState }));
  }

  generateSubscriberReport () {

    this.spinner.show();

    this.ppwSerivce.getSubscriberReport()
      .subscribe(
        _ => {

          this.spinner.hide();
          this.dialogService.alert("Success!", "An email with a report on your subscribers and their subscriptions have been sent to your inbox.", this.viewRef);
        },
        error => {

          this.spinner.hide();
          this.dialogService.alert("Uh oh!", `Something went wrong when trying to send that email. Please contact support at support@connectwithcue.com. ${error.error}`, this.viewRef);
        }
      );
  }
}
